import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';





const UGC_SectionModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const [subjects, setSubjects] = useState([]);
    const [selectedSubjects, setSelectedSubjects] = useState([]);

    let initialData = {
        ExamType: 'Select Section Type',
        Section: '',
        Subject: 'Select Subject',
        SubjectID: 0,
        Sn: 0,
        DisplayOrder: 0
    }


    const [examBodyData, setExamBodyData] = useState(initialData);


    console.log(examBodyData);
    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            if (item.Sn > 0) {
                setExamBodyData(item)
            }
            setModalBox(true);

        }
    }));

    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/ugc/subjects').then((response) => {
            setSubjects(response.data.subjects);
            setSelectedSubjects(response.data.subjects.filter((subject) => subject.ExamType === examBodyData.ExamType));

        }).catch((error) => {
            console.error('Error fetching subjects:', error);
            toast.error('Failed to fetch subjects');
        }
        );
    }, []);

    const hanldeSaveExamBody = async () => {
        try {
            if (examBodyData.Section.trim().length === 0) {
                toast.error("Please Enter Topics")
                return;
            } else if (examBodyData.Subject.trim().length === 0 || examBodyData.Subject === 'Select Subject Type') {
                toast.error("Please select Subject")
                return;
            }
            const response = await axios.post(BACKEND_SERVER_URL + `${!examBodyData.Sn ? '/ugc/createSection' : `/ugc/updateSection`}`, examBodyData);
            toast.success(response.data.message);
        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message)
        } finally {
            props.setSubjectLoading(!props.loadSubjects);
            setExamBodyData(initialData)
            setModalBox(false);
            setExamBodyData(initialData);
        }

    }
    console.log(subjects);
    return (
        <>
            <Modal onHide={setModalBox} show={modalBox} size="md" backdrop="static"
                keyboard={false} >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel"> {examBodyData.Sn ? "Update Topics" : "Create Topics"}</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label htmlFor="sessioncount" className="form-label text-primary">SECTION TYPE<span className="required">*</span></label>
                             <Select
                                value={{
                                    value: examBodyData.ExamType,
                                    label: examBodyData.ExamType === 'GENERAL APTITUDE' ? 'Teaching & Research Aptitude' : examBodyData.ExamType === 'SUBJECT SPECIFIC' ? 'Academic Subjects' : examBodyData.ExamType
                                }}
                                onChange={(selectedOption) => {
                                    setExamBodyData({ ...examBodyData, ExamType: selectedOption.value });
                                    setSelectedSubjects(subjects.filter((subject) => subject.ExamType === selectedOption.value));
                                }}
                                options={[
                                    { value: 'SUBJECT SPECIFIC', label: 'Academic Subjects' },
                                    { value: 'GENERAL APTITUDE', label: 'Teaching & Research Aptitude' }
                                ]}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        backgroundColor: 'transparent', // Adjust as needed
                                        borderColor: '#17a2b8', // Adjust as needed

                                    }),
                                }}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="sessioncount" className="form-label text-primary">SUBJECT NAME<span className="required">*</span></label>
                            <Select
                                value={{ value: examBodyData.Subject, label: examBodyData.Subject }}
                                onChange={(selectedOption) => {
                                    setExamBodyData({ ...examBodyData, Subject: selectedOption.value.Subject, SubjectID: selectedOption.value.Sn })
                                }}
                                options={[...(selectedSubjects || [])].sort((a,b) => a.Subject?.localeCompare(b.Subject)).map((course) => ({ value: course, label: course.Subject }))}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        backgroundColor: 'transparent', // Adjust as needed
                                        borderColor: '#17a2b8', // Adjust as needed

                                    }),
                                }}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="subjects" className="form-label text-primary">Topics<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="text" name="" id="subjects" value={examBodyData.Section} onChange={(e) => setExamBodyData({ ...examBodyData, Section: e.target.value })} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="displayOrder" className="form-label text-primary">ORDER PREFERENCE</label>
                            <input className='form-control' type="number" min="0" id="displayOrder" value={examBodyData.DisplayOrder} onChange={(e) => setExamBodyData({ ...examBodyData, DisplayOrder: e.target.value })} placeholder="e.g. 1, 2, 3... (0 for alphabetical)" />
                        </div>



                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                        <button type="button" className="btn btn-primary btn-xs " onClick={hanldeSaveExamBody}>{examBodyData.Sn ? "Update" : "Create "}</button>
                    </div>
                </div>
            </Modal>

        </>
    )
})
export default UGC_SectionModal;